import { LayoutDashboard, Plus, Search } from "lucide-react";
import { NavLink } from "react-router";
import { ScopePillsV2 } from "./scope-pills";
import { CreateOrderButton } from "@/features/orders/create-order-button";
import { CreateTripButton } from "@/features/trips/create-trip-button";

function Bolt({ size = 24 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
      <path
        d="M13 2 L4 14 H10.5 L9 22 L20 9 H13 Z"
        fill="#ffe62d"
        stroke="#111"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface CommandBarProps {
  lookupActive: boolean;
  onToggleLookup: () => void;
}

export function CommandBar({ lookupActive, onToggleLookup }: CommandBarProps) {
  return (
    <header className="z-30 flex h-16 min-w-0 shrink-0 items-center gap-2 border-b border-zinc-200 bg-white px-2 sm:gap-3 sm:px-4">
      <Bolt size={26} />
      <div className="h-7 w-px bg-zinc-200" />

      {/* Carrier / center / date / window scope — v2-native pills. */}
      <div className="ml-1 min-w-0 flex-1 overflow-x-auto overflow-y-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <ScopePillsV2 />
      </div>

      <div className="ml-auto flex shrink-0 items-center gap-1 sm:gap-2">
        <button
          type="button"
          aria-label="Lookup"
          onClick={onToggleLookup}
          className={
            "inline-flex h-10 w-10 items-center justify-center gap-1.5 rounded-lg text-[13px] font-semibold transition-colors 2xl:w-auto 2xl:px-3 " +
            (lookupActive
              ? "bg-indigo-50 text-indigo-700"
              : "text-zinc-600 hover:bg-zinc-100")
          }
        >
          <Search className="h-4 w-4" />{" "}
          <span className="hidden 2xl:inline">Lookup</span>
        </button>

        <NavLink
          to="/fulfillment/orders"
          title="Open the fulfillment dashboard"
          aria-label="Dashboard"
          className="inline-flex h-10 w-10 items-center justify-center gap-1.5 rounded-lg text-[13px] font-semibold text-zinc-600 transition-colors hover:bg-zinc-100 2xl:w-auto 2xl:px-3"
        >
          <LayoutDashboard className="h-4 w-4" />{" "}
          <span className="hidden 2xl:inline">Dashboard</span>
        </NavLink>

        <CreateOrderButton
          trigger={
            <button
              type="button"
              aria-label="Create order"
              className="inline-flex h-10 items-center justify-center gap-1.5 rounded-lg border border-zinc-200 px-3 text-[13px] font-semibold text-zinc-700 hover:bg-zinc-50"
            >
              <Plus className="h-3.5 w-3.5" strokeWidth={2.5} />{" "}
              <span>Order</span>
            </button>
          }
        />
        <CreateTripButton
          trigger={
            <button
              type="button"
              aria-label="Create trip"
              className="inline-flex h-10 items-center justify-center gap-1.5 rounded-lg bg-indigo-600 px-3 text-[13px] font-semibold text-white hover:bg-indigo-700"
            >
              <Plus className="h-3.5 w-3.5" strokeWidth={2.5} />{" "}
              <span>Trip</span>
            </button>
          }
        />
      </div>
    </header>
  );
}
